export const CREATION_TYPE = {
  WALDOGRAM: 'WALDOGRAM',
  COLLAGE: 'COLLAGE',
  CAMPERGRAM: 'CAMPERGRAM',
};

export const WALDOGRAM_STATUS = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
};
